import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { OrganizerChallenge } from '@radevents/shared';
import { OrganizerChallengeSection } from './TeamParts';
import { useAuth } from '../../contexts/AuthContext';
import challengeService from '../../services/challengeService';

/**
 * Abschnitt Winterchallenge auf `/veranstalter/:id`. Der Server entscheidet, ob es etwas zu zeigen
 * gibt (Team vorhanden oder das Konto verwaltet den Verein), sonst steht hier nichts.
 */
export default function OrganizerChallengeBlock({ organizerId, organizerName }: { organizerId: number; organizerName: string }) {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState<OrganizerChallenge | null>(null);

  useEffect(() => {
    let alive = true;
    challengeService.forOrganizer(organizerId).then(d => { if (alive) setData(d); }).catch(() => {});
    return () => { alive = false; };
  }, [organizerId, isAuthenticated]);

  if (!data) return null;
  return (
    <div className="wc-orgsec-wrap">
      <OrganizerChallengeSection
        summary={data.summary}
        team={data.team}
        canManage={data.canManage}
        onCreateTeam={() => navigate(`/winterchallenge/team-gruenden?verein=${organizerId}&name=${encodeURIComponent(organizerName)}`)}
      />
    </div>
  );
}
